import React from 'react';
import ProductHubDashboardV2 from '../ProductHubDashboard/ProductHubDashboardV2';

const VippHubView = () => {
  return <ProductHubDashboardV2 productCode="vipp" productLabel="VIP Phone Support" />;
};

export default VippHubView;
